<template>
  <section class="section section--gray">
    <div class="container">
      <div class="section__header section__header--center">
        <span class="section__label">Для кого</span>
        <h2 class="section__title">Каждому — своя выгода от одного расчёта</h2>
        <p class="section__subtitle">Одни и те же формулы и данные — четыре разных рабочих места</p>
      </div>
      <div class="audience-grid">
        <div v-for="item in audience" :key="item.title" class="audience-card">
          <div class="audience-card__icon">
            <ui-icon :name="item.icon" :size="26" />
          </div>
          <h3 class="audience-card__title">{{ item.title }}</h3>
          <p class="audience-card__text">{{ item.text }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import UiIcon from '../ui/UiIcon.vue'
export default {
  name: 'AudienceSection',
  components: { UiIcon },
  data() {
    return {
      audience: [
        {
          icon: 'target',
          title: 'HR / C&B',
          text: 'Расчёт за минуты вместо дней. Формулы и KPI меняются без программиста и без страха сломать файл.',
        },
        {
          icon: 'bar-chart',
          title: 'Бухгалтерия',
          text: 'Авторитетный серверный расчёт и готовая ведомость в Excel/CSV — цифрам можно доверять.',
        },
        {
          icon: 'users',
          title: 'Руководитель',
          text: 'Премии и KPI команды онлайн; доступ к подчинённым — одним назначением на подразделение.',
        },
        {
          icon: 'zap',
          title: 'Сотрудник',
          text: 'Своя премия и KPI-карта онлайн, с расчётом «почему столько» — на телефоне и в тёмной теме.',
        },
      ],
    }
  },
}
</script>

<style scoped>
.audience-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}
.audience-card {
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 28px;
  transition: var(--transition);
}
.audience-card:hover { box-shadow: var(--shadow); }
.audience-card__icon {
  width: 48px; height: 48px;
  border-radius: 12px;
  background: var(--primary-light);
  color: var(--primary);
  display: flex; align-items: center; justify-content: center;
  margin-bottom: 16px;
}
.audience-card__title {
  font-size: 1.0625rem;
  font-weight: 700;
  margin-bottom: 8px;
  color: var(--dark);
}
.audience-card__text { color: var(--gray); font-size: 0.9375rem; line-height: 1.6; }

@media (max-width: 1000px) {
  .audience-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 600px) {
  .audience-grid { grid-template-columns: 1fr; }
}
</style>
